import { useUserRoles } from '@anytag/auth';
import { usePartnerAgencyPermissionQuery } from '@anytag/graphql';
import { RenderDataWithFallback } from '@anytag/shared-atoms';
import { EngagementCampaignProposal } from '@anytag/shared-organisms';
import { useEngagementDetailsContext } from '../engagement-details-context';

export const EngagementProposal = () => {
  const { engagement, engagementProposal, hasTrackingReferral } = useEngagementDetailsContext();
  const { isPartner } = useUserRoles();
  const { data, loading } = usePartnerAgencyPermissionQuery({ skip: !isPartner });

  const hasInfluencerCostPermission = isPartner ? !!data?.partnerAgencyPermission?.influencerCostPermission : true;

  return (
    <RenderDataWithFallback loading={loading}>
      <EngagementCampaignProposal
        engagement={engagement}
        engagementProposal={engagementProposal}
        hasTrackingReferral={hasTrackingReferral}
        hasInfluencerCostPermission={hasInfluencerCostPermission}
      />
    </RenderDataWithFallback>
  );
};
